import React from 'react';
import PropTypes from 'prop-types';

import Form from '../../../../components/Form';
import withCollegeService from '../withCollegeService';
import messages from './messages';

export const WomenComponent = ({ onChange, initialValue, formatMessage }) => (
  <Form.Input
    type="number"
    min="0"
    fluid
    label={formatMessage(messages.undergraduateWomen)}
    placeholder={formatMessage(messages.undergraduateWomen)}
    value={initialValue.value}
    data-cy="premium-Hem-Undergrad-Enrollment-Number-Of-Women"
    onChange={(e, { value }) => {
      onChange(e, { value });
    }}
  />
);
WomenComponent.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
};

const Women = withCollegeService(WomenComponent, 'studentLife.schoolSize.undergraduateWomen', null, {
  value: 'field_he_numugfemales',
});

export const MenComponent = ({ onChange, initialValue, formatMessage }) => (
  <Form.Input
    type="number"
    min="0"
    fluid
    label={formatMessage(messages.undergraduateMen)}
    placeholder={formatMessage(messages.undergraduateMen)}
    value={initialValue.value}
    data-cy="premium-Hem-Undergrad-Enrollment-Number-Of-Men"
    onChange={(e, { value }) => {
      onChange(e, { value });
    }}
  />
);
MenComponent.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
};

const Men = withCollegeService(MenComponent, 'studentLife.schoolSize.undergraduateMen', null, {
  value: 'field_he_numugmales',
});

const UndergraduateEnrollment = ({ formatMessage }) => (
  <Form>
    <Women formatMessage={formatMessage} />
    <Men formatMessage={formatMessage} />
  </Form>
);
UndergraduateEnrollment.propTypes = {
  formatMessage: PropTypes.func,
};

export default UndergraduateEnrollment;
